import { Phone, Mail, MapPin, Clock } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-blue-950 text-white py-12" data-testid="footer">
      <div className="section-container">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/images/logo.webp" alt="Sky's PhysioRehab Logo" className="w-12 h-12 object-contain bg-white rounded-lg p-1" />
              <div>
                <p className="font-serif font-bold text-base text-white">Sky's PhysioRehab</p>
                <p className="text-sm text-blue-300">& Slimming Centre</p>
              </div>
            </div>
            <p className="text-blue-300 text-sm mb-4">
              Specialized in Diastasis Recti Treatment & Post Pregnancy Physiotherapy in Lucknow.
            </p>
            <p className="text-blue-400 text-xs">
              Dr. Seema Chaudhary (DPT, BPT & DR Certified)
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2 text-blue-300 text-sm">
              <li><a href="/#about" className="hover:text-white transition-colors">About Dr. Seema</a></li>
              <li><a href="/#treatment" className="hover:text-white transition-colors">Treatment Approach</a></li>
              <li><a href="/#results" className="hover:text-white transition-colors">Results</a></li>
              <li><a href="/#faq" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href="/#booking" className="hover:text-white transition-colors">Book Consultation</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Services</h4>
            <ul className="space-y-2 text-blue-300 text-sm">
              <li>Diastasis Recti Treatment</li>
              <li>Post Pregnancy Physiotherapy</li>
              <li>Core Strength Rehabilitation</li>
              <li>Back Pain Management</li>
              <li>Posture Correction</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Contact Us</h4>
            <ul className="space-y-3 text-blue-300 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="flex-shrink-0 mt-0.5" />
                <span>3/173, Vikrant Khand 3, Gomti Nagar, Lucknow - 226010</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} />
                <a href="tel:+918800095625" className="hover:text-white transition-colors">+91 88000 95625</a>
              </li>
              <li className="flex items-center gap-3">
                <Clock size={18} />
                <span>Mon-Sat: 9:30 AM - 7:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-blue-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-blue-300 text-sm">
            <div className="text-center md:text-left">
              <p>© {currentYear} Sky's PhysioRehab & Slimming Centre. All rights reserved.</p>
              <p className="mt-1 text-xs text-blue-500/80">
                Designed & developed by <a href="https://nirosha.org" target="_blank" rel="noopener noreferrer" className="hover:text-pink-400 transition-colors">Team Nirosha</a>.
                Powered by <a href="https://wasms.nirosha.org" target="_blank" rel="noopener noreferrer" className="hover:text-pink-400 transition-colors">WASMS</a>.
              </p>
            </div>
            <div className="flex items-center gap-6">
              <a href="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
